import { createUseStyles } from 'react-jss';
export default createUseStyles(function (theme) {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px 25px',
      borderRadius: 5,
      width: '100%',
      maxWidth: 330,
      textAlign: 'left'
    },
    default: {
      backgroundColor: theme.palette.grey[1]
    },
    primary: {
      backgroundColor: theme.palette.primary.light
    },
    secondary: {
      backgroundColor: theme.palette.secondary.light
    },
    success: {
      backgroundColor: theme.palette.success.regular
    },
    warning: {
      backgroundColor: theme.palette.warning.light
    },
    danger: {
      backgroundColor: theme.palette.danger.regular
    },
    primary_regular: {
      backgroundColor: theme.palette.primary.regular
    },
    secondary_regular: {
      backgroundColor: theme.palette.secondary.regular
    },
    success_regular: {
      backgroundColor: theme.palette.success.regular
    },
    warning_regular: {
      backgroundColor: theme.palette.warning.regular
    },
    danger_regular: {
      backgroundColor: theme.palette.danger.regular
    }
  };
});